<script>
    import {incrementItemInCart, decrementItemInCart} from "./cart-store.js";
    import Image from "../components/Image.svelte";
    import {t} from "../core/i18n/language-store.js";

    export let item;
    export let publishConfig;
    export let tenantKey;
</script>

<style>
    :root {
        --image-size: 4.1875rem;
    }

    .item-container {
        display: flex;
        gap: 0.875rem;
    }
    .image-block {
        background: #eee;
        width: var(--image-size);
        height: var(--image-size);
        min-width: var(--image-size);
        min-height: var(--image-size);
        border-radius: 1rem;
    }
    .info-block {
        flex: 1 1;
        min-height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-weight: 400;
    }
    .item-title {
        font-size: var(--fs-100);
        line-height: 1.2;
        padding-bottom: .25rem;
        font-weight: 400;

        overflow-wrap: break-word;
        word-break: break-word;
    }
    .item-price {
        font-size: var(--fs-120);
        font-weight: 600;
    }
    .count {
        display: flex;
        align-items: center;
        gap: .35rem;
        font-weight: 600;
        font-size: var(--fs-120);
    }
        button {
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        border: none;
        background: transparent;
        font-size: var(--fs-120);
        color: var(--price-item-bg-color);
        padding: 0;
    }
</style>


<div class="item-container">
    <div class="image-block">
        <Image src={item.img} tenantKey={item.ref || tenantKey} fillContainer={true}></Image>
    </div>
    <div class="info-block">
        <div class="item-title">
            { item.name || $t('cart.unnamed') }{#if (item.weight !== undefined)}, { item.weight }{/if}
            {#if (item.modsDescription?.length > 0)}
                <br>
                <span class="fs-85">{ item.modsDescription }</span>
            {/if}
        </div>

        <div style="display: flex; justify-content: space-between; align-items: center;">
            <div class="item-price">
                {#if (item.price !== null && item.price !== undefined)}
                    <span>{ item.price } {publishConfig?.currency ? publishConfig.currency : ''}</span>
                {/if}
            </div>
            <div class="count">
                <button class="pointer" on:click={() => decrementItemInCart(item, item.price, item.priceIndex, item.mods)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="ai ai-CircleMinus"><path d="M16 12H8"/><circle cx="12" cy="12" r="10"/></svg>
                </button>
                <span>{ item.count }</span>
                <button class="pointer" on:click={() => incrementItemInCart(item, item.price, item.priceIndex, item.mods)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="ai ai-CirclePlus"><path d="M12 8v4m0 0v4m0-4h4m-4 0H8"/><circle cx="12" cy="12" r="10"/></svg>
                </button>
            </div>
        </div>
    </div>
</div>
